var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit (1) 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11 4.0625H4C3.46957 4.0625 2.96086 4.27321 2.58579 4.64829C2.21071 5.02336 2 5.53207 2 6.0625V20.0625C2 20.5929 2.21071 21.1016 2.58579 21.4767C2.96086 21.8518 3.46957 22.0625 4 22.0625H18C18.5304 22.0625 19.0391 21.8518 19.4142 21.4767C19.7893 21.1016 20 20.5929 20 20.0625V13.0625",
    stroke: "#19C489",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.5 2.56273C18.8978 2.1649 19.4374 1.94141 20 1.94141C20.5626 1.94141 21.1022 2.1649 21.5 2.56273C21.8978 2.96055 22.1213 3.50012 22.1213 4.06273C22.1213 4.62534 21.8978 5.1649 21.5 5.56273L12 15.0627L8 16.0627L9 12.0627L18.5 2.56273Z",
    stroke: "#19C489",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.0ecd3be6cc2ec2b9c186aa81c5dadbeb.svg";
export { ForwardRef as ReactComponent };